import { create } from 'zustand';

type ScopeOverlayState = {
  /**
   * Bumped by every request to open the overlay. A counter rather than a
   * boolean: the overlay closes on its own terms, so a second request has to be
   * distinguishable from the first even when nothing else changed.
   */
  openRequestId: number;
  /** Whether the request wants the target field opened for editing. */
  focusTarget: boolean;
};

const useScopeOverlayStore = create<ScopeOverlayState>(() => ({
  openRequestId: 0,
  focusTarget: false,
}));

/**
 * Ask the scope overlay to open — from the target line in the proposals chart,
 * which is a view of the very scope the overlay edits.
 */
export const requestScopeOverlay = (
  options: { focusTarget?: boolean } = {},
): void =>
  useScopeOverlayStore.setState(({ openRequestId }) => ({
    openRequestId: openRequestId + 1,
    focusTarget: options.focusTarget ?? false,
  }));

/** The latest request, for the overlay to act on. */
export const useScopeOverlayRequest = (): ScopeOverlayState =>
  useScopeOverlayStore();
